module.exports = __webpack_public_path__ + "img/fala-comigo-bb-lg.cfb6bfd4.png";